import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import { restoreSigninLocation } from './signinNavigation';

const clients = {
  'https://api-dev.vertx.ai': 'vertx-portal-dev',
  'https://api-stg.vertx.ai': 'vertx-portal-stg',
  'https://api.vertx.ai': 'vertx-portal',
};

const clientId = clients[process.env.REACT_APP_VERTX_API_BASE || 'https://api-dev.vertx.ai'];
if (!clientId) {
  throw new Error('Missing Vertx OIDC client configuration');
}

export const userManager = new UserManager({
  authority: `https://auth.vertx.ai/application/o/${clientId}/`,
  client_id: clientId,
  redirect_uri: `${window.location.origin}/`,
  post_logout_redirect_uri: `${window.location.origin}/`,
  response_type: 'code',
  scope: 'openid email profile offline_access vertx_user_uuid',
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  automaticSilentRenew: true,
  revokeTokensOnSignout: true,
});

export const authProviderProps = {
  userManager,
  onSigninCallback: restoreSigninLocation,
};

export async function getPortalToken() {
  let user = await userManager.getUser();
  if (!user) {
    throw new Error('Sign in required');
  }
  if (user.expired) {
    user = await userManager.signinSilent();
  }
  if (!user || !user.access_token) {
    throw new Error('Sign in required');
  }
  return user.access_token;
}
